import { FormControlLabel, Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import ConfirmModal from "../modals/confirmModal/ConfirmModal";

const RefusesOAC = ({
  refusesOAC,
  anticoagStatus,
  handleRefuseOAC,
  isRefusesOACLoading,
  disable = false,
  label,
}) => {
  const [confirmRefusesOAC, setConfirmRefusesOAC] = useState(false);
  const [refuseOACStatus, setRefuseOACStatus] = useState(false);

  useEffect(() => {
    setRefuseOACStatus(refusesOAC);

    return () => {
      setRefuseOACStatus(false);
    };
  }, [refusesOAC]);

  return (
    <>
      <FormControlLabel
        label={label || "Refuses OAC"}
        labelPlacement="start"
        control={
          <Switch
            name="refusesOAC"
            checked={refuseOACStatus}
            disabled={disable}
            onChange={(event) => {
              const newRefusesOACStatus = event.target.checked;
              if (newRefusesOACStatus && anticoagStatus === "yes") {
                return setConfirmRefusesOAC(true);
              } else {
                handleRefuseOAC(event.target.checked);
              }
            }}
          />
        }
        style={{ marginLeft: 0, marginRight: "2px" }}
        className="toggle-label"
      />

      {confirmRefusesOAC && (
        <ConfirmModal
          confirmText="Confirm"
          title="Confirm Refuses OAC"
          show={confirmRefusesOAC}
          isConfirming={isRefusesOACLoading}
          onConfirm={() => {
            handleRefuseOAC(!refusesOAC, true);
            setConfirmRefusesOAC(false);
          }}
          onCancel={() => {
            handleRefuseOAC(refusesOAC);
            setConfirmRefusesOAC(false);
          }}
          children={
            <span>
              Updating this will automatically set <b>Anticoagulants Status</b>{" "}
              to <b>"No"</b>. Are you sure you want to confirm this change?
            </span>
          }
        />
      )}
    </>
  );
};

export default RefusesOAC;
